/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { changeUserEmail } from '../fn/admin/change-user-email';
import { ChangeUserEmail$Params } from '../fn/admin/change-user-email';
import { createBiddersForAuction } from '../fn/admin/create-bidders-for-auction';
import { CreateBiddersForAuction$Params } from '../fn/admin/create-bidders-for-auction';
import { deleteBidder } from '../fn/admin/delete-bidder';
import { DeleteBidder$Params } from '../fn/admin/delete-bidder';
import { enqueueAcceptedBidsForSixbidSync } from '../fn/admin/enqueue-accepted-bids-for-sixbid-sync';
import { EnqueueAcceptedBidsForSixbidSync$Params } from '../fn/admin/enqueue-accepted-bids-for-sixbid-sync';
import { mergeUsers } from '../fn/admin/merge-users';
import { MergeUsers$Params } from '../fn/admin/merge-users';
import { reassignBidder } from '../fn/admin/reassign-bidder';
import { ReassignBidder$Params } from '../fn/admin/reassign-bidder';
import { retrieveSixbidLotIds } from '../fn/admin/retrieve-sixbid-lot-ids';
import { RetrieveSixbidLotIds$Params } from '../fn/admin/retrieve-sixbid-lot-ids';

@Injectable({ providedIn: 'root' })
export class GeneratedAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `changeUserEmail()` */
  static readonly ChangeUserEmailPath = '/api/admin/users/change-email';

  /**
   * Changes the sign-in and contact email address of an user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeUserEmail()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  changeUserEmail$Response(params?: ChangeUserEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return changeUserEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * Changes the sign-in and contact email address of an user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeUserEmail$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  changeUserEmail(params?: ChangeUserEmail$Params, context?: HttpContext): Observable<void> {
    return this.changeUserEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reassignBidder()` */
  static readonly ReassignBidderPath = '/api/admin/bidders/reassign';

  /**
   * Assigns an existing bidder to another user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reassignBidder()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  reassignBidder$Response(params?: ReassignBidder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return reassignBidder(this.http, this.rootUrl, params, context);
  }

  /**
   * Assigns an existing bidder to another user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reassignBidder$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  reassignBidder(params?: ReassignBidder$Params, context?: HttpContext): Observable<void> {
    return this.reassignBidder$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `mergeUsers()` */
  static readonly MergeUsersPath = '/api/admin/users/merge';

  /**
   * Moves most of the source users data onto the target user, and deletes the source user afterwards.
   *
   * Note that on merge some data, like verifications and documents, will not get merged and get deleted instead.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mergeUsers()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  mergeUsers$Response(params?: MergeUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return mergeUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Moves most of the source users data onto the target user, and deletes the source user afterwards.
   *
   * Note that on merge some data, like verifications and documents, will not get merged and get deleted instead.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mergeUsers$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  mergeUsers(params?: MergeUsers$Params, context?: HttpContext): Observable<void> {
    return this.mergeUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `retrieveSixbidLotIds()` */
  static readonly RetrieveSixbidLotIdsPath = '/api/admin/retrievelotids/{auctionCatalogPartId}';

  /**
   * Retrieves the sixbid lot id for a given auction catalog part id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retrieveSixbidLotIds()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrieveSixbidLotIds$Response(params: RetrieveSixbidLotIds$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return retrieveSixbidLotIds(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the sixbid lot id for a given auction catalog part id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `retrieveSixbidLotIds$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrieveSixbidLotIds(params: RetrieveSixbidLotIds$Params, context?: HttpContext): Observable<void> {
    return this.retrieveSixbidLotIds$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `enqueueAcceptedBidsForSixbidSync()` */
  static readonly EnqueueAcceptedBidsForSixbidSyncPath = '/api/admin/enqueueacceptedBidIds/{auctionId}';

  /**
   * Enqueue all accepted bids for SixbidSync.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enqueueAcceptedBidsForSixbidSync()` instead.
   *
   * This method doesn't expect any request body.
   */
  enqueueAcceptedBidsForSixbidSync$Response(params: EnqueueAcceptedBidsForSixbidSync$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return enqueueAcceptedBidsForSixbidSync(this.http, this.rootUrl, params, context);
  }

  /**
   * Enqueue all accepted bids for SixbidSync.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enqueueAcceptedBidsForSixbidSync$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enqueueAcceptedBidsForSixbidSync(params: EnqueueAcceptedBidsForSixbidSync$Params, context?: HttpContext): Observable<void> {
    return this.enqueueAcceptedBidsForSixbidSync$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteBidder()` */
  static readonly DeleteBidderPath = '/api/admin/bidders/delete';

  /**
   * Deletes an existing bidder.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteBidder()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  deleteBidder$Response(params?: DeleteBidder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteBidder(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an existing bidder.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteBidder$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  deleteBidder(params?: DeleteBidder$Params, context?: HttpContext): Observable<void> {
    return this.deleteBidder$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createBiddersForAuction()` */
  static readonly CreateBiddersForAuctionPath = '/api/admin/bidders/createBiddersForAuction';

  /**
   * Creates bidders for an auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createBiddersForAuction()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createBiddersForAuction$Response(params?: CreateBiddersForAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createBiddersForAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates bidders for an auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createBiddersForAuction$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createBiddersForAuction(params?: CreateBiddersForAuction$Params, context?: HttpContext): Observable<void> {
    return this.createBiddersForAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
